import {NOOP_FUNCTION} from "../../stem-core/src/base/Utils";

import {apiUserPurchaseProduct} from "../state/PurchaseStore.js";
import {ProductStore} from "../state/ProductStore.js";
import {authService} from "./services/AuthService.js";


export class BlinkPaymentProcessor {
    makePaymentManualConfirmed(paymentRequest, callback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION) {
        this.makePayment(paymentRequest, callback, errorCallback, true);
    }

    getProduct(paymentRequest) {
        if (paymentRequest.productId) {
            return ProductStore.get(paymentRequest.productId);
        }
        const allowedProducts = ProductStore.filterBy({allowArbitrarySubproducts: true});
        if (allowedProducts.length != 1) {
            throw `Invalid product state ${allowedProducts.length}`;
        }
        return allowedProducts[0];
    }

    // TODO @Mihai Deprecate method, used now to simulate old microtransactions logic
    // TODO @branch nice design, async function with callback
    async makePayment(paymentRequest, callback = NOOP_FUNCTION, errorCallback = NOOP_FUNCTION, manualConfirmation = false) {
        // TODO(@sdk-deprecated): currencyIsoCode will be removed from both the payment request and the backend payload.
        const {
            amount,
            currencyIsoCode,
            currencyCode,
            currencyId,
            resourceId,
            comment,
            merchantId,
        } = paymentRequest;

        const product = this.getProduct(paymentRequest);

        let request = {
            ...comment,
            merchantId,
            amount,
            currencyId: currencyId || currencyCode || currencyIsoCode,
            products: {
                entries: [{
                    productId: product.id,
                    subproductId: resourceId,
                }]
            },
            useWalletFunds: "yes",
            isAutomatic: !manualConfirmation,  // TODO @branch move up the chain?
        }

        // TODO @branch don't send this if we're not logged in...
        if (!authService.isAuthenticated()) {
            errorCallback("Not authenticated");
            return;
        }

        try {
            const response = await apiUserPurchaseProduct(request);
            callback(response);
        } catch (error) {
            errorCallback(error);
        }
    }
}
